module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgpZb3UgYXJlIGEgcHJvIG5vdyEK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/ventureCapital_complete.md
// module id = 1416
// module chunks = 0